<template>
  <div style="position: relative">
    <h4>Noga-Branchen</h4>
    <button
      v-if="!editMode && canUserEdit"
      v-b-tooltip.hover
      class="btn btn-primary"
      placement="top"
      style="position: absolute; top: 0; right: 0; z-index: 1"
      title="NOGA-Branchen bearbeiten"
      type="button"
      @click="editMode = !editMode"
    >
      <i class="fas fa-edit" />
    </button>
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
    />
    <u-loader v-if="isLoading" />
    <div class="containerNogaBranches">
      <div style="width: 200%">
        <u-tree-view
          v-if="!isLoading"
          v-model="selectedPaths"
          :disabled="isTreeDisabled"
          :open-node-ids="treeNodesToOpen"
          :tree-view-items="treeViewData"
        />
      </div>
    </div>

    <u-validation-checker
      v-model="requiredProperties"
      :is-empty="selectedPaths.length == 0"
      property-name="selectedPaths"
      section="Noga-Branchen"
    />

    <div
      v-if="editMode && canUserEdit"
      class="mt-4"
    >
      <button
        v-b-tooltip.hover
        :disabled="requiredProperties.length != 0"
        class="btn btn-success ml-2"
        placement="bottom"
        title="Speichern"
        type="button"
        @click="saveNogaBranches()"
      >
        Speichern
      </button>

      <button
        v-b-tooltip.hover
        class="btn btn-danger ml-2"
        placement="bottom"
        title="Abbrechen"
        type="button"
        @click="loadAllNogaBranches()"
      >
        Abbrechen
      </button>
    </div>
  </div>
</template>

<script>
    import { GetAllNogaBranches } from "@/services/nogaBranches.service.js";
    import UTreeView from "@/components/common/UTreeView.vue";
    import {
        CreateTreeView,
        GetAllNodeIdsInPathOfSelectedBranches,
    } from "@/helpers/TreeViewHelper.js";
    import {
        GetNogaBranchesForEdition,
        SaveNogaBranchesForEdition,
    } from "@/services/contract.edition.nogaBranches.service.js";

    export default {
        components: {
            UTreeView,
        },
        props: {
            contractId: {
                type: String,
                default: "",
            },
            versionId: {
                type: Number,
                default: 0,
            },
            editionId: {
                type: Number,
                default: 0,
            },
            canUserEdit: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                errorObject: null,
                allNogaBranches: [],
                treeViewData: [],
                selectedPaths: [],
                isLoading: false,
                requiredProperties: [],
                treeNodesToOpen: [],
                editMode: false,
            };
        },
        computed: {
            isTreeDisabled() {
                return !this.editMode || !this.canUserEdit;
            },
        },
        created() {
            this.loadAllNogaBranches();
        },
        methods: {
            loadEditionNogaBranches() {
                this.isLoading = true;

                GetNogaBranchesForEdition(
                    this.contractId,
                    this.versionId,
                    this.editionId,
                    (response) => {
                        this.selectedPaths = [];

                        if (response && response.length > 0) {
                            response.map((nogaBranch) => {
                                this.selectedPaths.push(nogaBranch.path);
                            });
                        }

                        this.isLoading = false;
                        this.treeNodesToOpen = GetAllNodeIdsInPathOfSelectedBranches(
                            this.allNogaBranches,
                            this.selectedPaths,
                        );
                    },
                    (error) => {
                        this.errorObject = error;
                        this.isLoading = false;
                    },
                );
            },
            loadAllNogaBranches() {
                this.isLoading = true;
                this.errorObject = null;
                this.editMode = false;

                GetAllNogaBranches(
                    (response) => {
                        this.allNogaBranches = response;

                  
                        this.createTreeViewJson();

                        this.isLoading = false;
                        this.loadEditionNogaBranches();
                    },
                    (error) => {
                        this.isLoading = false;
                        this.errorObject = error;
                    },
                );
            },
            createTreeViewJson() {
                this.treeViewData = CreateTreeView(this.allNogaBranches);
            },
            selectedNogaBranchesChanged(selectedItems) {
                this.selectedPaths = selectedItems;
               
            },
            saveNogaBranches() {
                this.isLoading = true;

                var allNogaBranchesObject = [];

                this.selectedPaths.map((selectedBranch) => {
                    allNogaBranchesObject.push({
                        path: selectedBranch,
                    });
                });



                SaveNogaBranchesForEdition(
                    this.contractId,
                    this.versionId,
                    this.editionId,
                    allNogaBranchesObject,
                    () => {
                        this.isLoading = false;
                        this.editMode = false;
                    },
                    (error) => {
                        this.errorObject = error;
                        this.isLoading = false;
                    },
                );
            },
        },
    };
</script>

<style scoped>
    .containerNogaBranches {
        overflow-x: scroll;
        overflow-y: hidden;
        width: 100%;
        white-space: nowrap;
        -webkit-overflow-scrolling: touch;
    }
</style>
